import template from './ipaf-input.html';

class IpafInputController {
  constructor() {
    this.value = null;
  }

  $onInit() {
    this.formName = `inputAddForm${Math.floor(Math.random() * 100)}`;
  }

  add() {
    if (this.formName.$invalid) return;
    this.onAdd({ value: this.value });
    this.value = null;
  }
}

export default {
  template,
  controller: IpafInputController,
  controllerAs: 'ipafInputVm',
  bindings: {
    onAdd: '&',
  },
};
